import createSvgIcon from '@icons/utils/create-svg-icon';
import ConnectSvg from './svg/connect.svg';

const ConnectIcon = createSvgIcon(ConnectSvg);

export default ConnectIcon;
